const normalizeTitle = (title = '') => title
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ')
  .trim();

export const isSalesTeamTitle = (title) => /\bsales\b/.test(normalizeTitle(title));
